var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderBorad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 180,
    viewBox: "0 0 300 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32811_548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 300,
    height: 180
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 180,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32811_548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.194 116.962C228.231 133.69 191.268 160.235 181.836 138.202C176.458 119.061 199.33 111.846 213.585 107.748C216.079 104.396 216.767 53.8987 234.115 52.0278C242.493 51.1244 232.648 96.0515 230.194 116.962Z",
    fill: "#085078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9998 148C90.1261 154.768 127.392 174.301 132.21 135.034C127.783 126.709 91.9998 130.5 91.9998 130.5C91.9998 130.5 61.6113 91.0828 47.9996 102C41.4267 107.272 63.1004 140.833 76.9998 148Z",
    fill: "#085078"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.723 108.788C201.491 94.9959 203.932 76.9927 202.575 61.459C202.236 32.6054 173.508 13.5875 143.041 16.2479C112.574 18.9082 92.9403 47.8709 94.9474 70.8567C96.3408 86.8145 103.812 103.111 112.282 116.074C115.245 120.609 119.755 124.441 125.375 127.298C124.579 128.281 123.907 129.458 123.391 130.857C112.775 159.635 105.318 191.702 120.171 205.218C156.85 215.866 195.556 215.587 205.592 208.769C219.583 199.263 202.356 152.803 196.371 137.333C194.087 131.429 190.804 123.219 187.801 120.542C191.002 117.432 193.723 113.572 195.723 108.788Z",
    fill: "url(#paint0_linear_32811_548)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.096 128.246C137.049 128.243 137.003 128.241 136.958 128.239C137.002 128.235 137.048 128.238 137.096 128.246C143.081 128.518 168.842 126.913 172.041 123.198C176.072 118.518 169.834 136.888 166.543 139.367C160.737 143.742 157.923 143.653 152.348 142.316C145.022 140.56 139.295 128.604 137.096 128.246Z",
    fill: "#064365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.852 76.2904C197.656 71.2388 197.738 71.9844 199.219 61.8878C200.699 51.7911 186.414 46.6955 178.097 41.3808C169.78 36.0662 165.334 30.1117 145.602 32.4386C125.871 34.7656 124.167 42.9253 118.525 47.4887C112.882 52.052 103.807 47.4565 100.22 69.4749C98.8429 81.425 108.236 106.077 118.797 116.33C129.357 126.584 143.213 129.603 157.002 128.399C167.943 127.443 184.824 118.418 193.146 99.5692C195.71 93.7595 195.681 83.6416 196.852 76.2904Z",
    fill: "#064365"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32811_548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.777 75.177C126.233 73.7862 123.725 72.3008 121.255 70.7468C120.178 70.0671 119.086 69.3416 117.958 68.7108C117.778 68.6101 117.572 68.5697 117.368 68.5949C117.163 68.6201 116.969 68.7098 116.812 68.8521C115.569 69.9955 114.586 71.4175 113.94 73.0086C113.293 74.5998 113 76.3176 113.083 78.0298C113.25 80.8501 114.414 83.4815 116.348 85.4102C118.281 87.3389 120.846 88.4265 123.541 88.4607C126.088 88.4661 128.573 87.5188 130.55 85.7887C132.527 84.0585 133.867 81.6587 134.329 79.0198C134.362 78.791 134.325 78.5587 134.221 78.3572C134.118 78.1558 133.956 77.9959 133.757 77.9013C132.128 77.0025 130.453 76.0856 128.777 75.177Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_32811_548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.957 69.8348C175.411 68.2901 177.823 66.6532 180.192 64.9503C181.226 64.2056 182.271 63.4143 183.358 62.7153C183.531 62.6037 183.734 62.5507 183.94 62.5633C184.146 62.5759 184.345 62.6535 184.511 62.7858C185.822 63.8506 186.89 65.2094 187.633 66.7578C188.376 68.3061 188.774 70.0027 188.797 71.7168C188.804 74.542 187.804 77.24 185.993 79.284C184.181 81.328 181.688 82.5713 179 82.7713C176.458 82.9334 173.92 82.1407 171.84 80.5354C169.761 78.9302 168.276 76.6174 167.652 74.0119C167.605 73.7856 167.628 73.5514 167.719 73.3439C167.809 73.1365 167.962 72.9669 168.154 72.8603C169.725 71.8629 171.34 70.8448 172.957 69.8348Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.663 78.7239C192.988 83.7603 185.876 90.7839 177.194 91.542C170.856 92.0954 167.991 90.0457 165.079 87.9629C162.073 85.8118 159.016 83.6255 152.034 84.2351C145.089 84.8415 142.595 87.4861 140.128 90.1025C137.713 92.6638 135.322 95.1981 128.807 95.767C118.274 96.6868 107.077 91.3317 103.078 88.5122C106.522 99.0823 112.398 110.251 118.69 116.339C129.281 126.59 143.18 129.605 157.013 128.397C167.989 127.439 184.927 118.409 193.28 99.557C195.012 95.6487 195.567 89.7916 196.102 84.1383C196.278 82.2864 196.451 80.4563 196.663 78.7239Z",
    fill: "#0193D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.462 43.9058C212.812 45.2857 215.216 55.7241 218.931 62.1546C222.723 68.7168 228.502 75.4274 238.06 66.2933C245.55 59.136 236.111 42.526 224.462 43.9058Z",
    fill: "#085078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8696 89.9245C59.4454 88.024 60.0263 98.7199 58.2374 105.928C56.4119 113.283 52.7175 121.332 41.0032 115.202C31.8241 110.399 36.2938 91.8249 47.8696 89.9245Z",
    fill: "#085078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3282 62.1063L48.057 65.3531L56.9215 68.824L58.3939 65.0636L49.3282 62.1063Z",
    fill: "#FCAB28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2652 52.0066C34.954 51.8847 34.6436 51.7043 34.3413 51.4665C33.944 51.1549 33.8744 50.5784 34.1866 50.1784C34.4983 49.7799 35.0738 49.7091 35.4725 50.0212C35.6898 50.1923 36.1035 50.4577 36.4246 50.3192C36.7456 50.1806 37.13 49.6003 37.2466 48.3818C37.4443 46.3195 35.6991 41.9393 32.4571 36.3649C30.495 32.9968 30.4468 28.7844 32.3419 26.5683C33.4998 25.213 35.23 24.854 37.0902 25.5824C38.5139 26.1398 39.4517 26.9448 39.8753 27.972C40.5383 29.5801 39.7875 31.2906 39.2404 32.5379C39.0425 32.9906 38.8368 33.4593 38.7959 33.7219C38.7919 33.7442 38.7931 33.7574 38.7934 33.7607C38.9071 34.0138 40.0497 34.3402 41.1685 34.342C41.6734 34.3423 42.0823 34.7539 42.0806 35.2612C42.0789 35.7684 41.6679 36.1774 41.1616 36.1766C40.7059 36.1765 38.386 36.1151 37.4126 34.9714C37.0437 34.5388 36.8966 34.0099 36.9852 33.4428C37.0633 32.9432 37.2956 32.4149 37.5636 31.8034C38.0241 30.753 38.5477 29.5617 38.1819 28.675C37.9553 28.1262 37.3642 27.6607 36.421 27.2914C35.2823 26.8455 34.3777 27.0024 33.7321 27.759C32.5417 29.1525 32.3198 32.4854 34.0375 35.4394C36.499 39.6733 39.3713 45.3848 39.0675 48.5535C38.8981 50.3165 38.2154 51.541 37.1435 52.0033C36.5513 52.2586 35.906 52.2559 35.2644 52.0047L35.2652 52.0066Z",
    fill: "#FCAB28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3276 68.0844C75.6874 67.8337 75.2118 67.3975 74.949 66.8074C74.476 65.7402 74.8062 64.3777 75.8789 62.9684C77.8074 60.4358 83.7928 58.1925 88.4761 56.7561C91.7428 55.7537 93.8429 53.1562 93.9152 51.3249C93.9536 50.3306 93.3959 49.6012 92.2586 49.1558C91.3168 48.7871 90.5654 48.7269 90.0264 48.976C89.1571 49.3791 88.7318 50.6073 88.3562 51.6925C88.1377 52.3234 87.9495 52.869 87.6676 53.2888C87.3471 53.7667 86.8787 54.0546 86.316 54.1208C84.8253 54.2982 83.0805 52.768 82.7453 52.4601C82.3731 52.1169 82.351 51.5367 82.6922 51.164C83.0354 50.7905 83.6132 50.7668 83.9859 51.1085C84.8119 51.8666 85.8723 52.4028 86.1276 52.2942C86.1276 52.2942 86.1361 52.2848 86.1483 52.2657C86.2971 52.0437 86.4638 51.5613 86.6259 51.0946C87.0717 49.806 87.6814 48.0419 89.26 47.3115C90.2684 46.845 91.5021 46.8902 92.9272 47.4482C94.7874 48.1766 95.8138 49.6149 95.7437 51.3961C95.6303 54.3098 92.7333 57.369 89.0082 58.5119C82.8431 60.4031 78.5877 62.4337 77.3325 64.0821C76.5914 65.0544 76.479 65.7428 76.6206 66.0625C76.7622 66.3822 77.2449 66.4677 77.5205 66.4897C78.0251 66.5312 78.3996 66.974 78.3578 67.4782C78.316 67.9825 77.8734 68.3584 77.3697 68.3188C76.9863 68.2881 76.6358 68.2098 76.3246 68.088L76.3276 68.0844Z",
    fill: "#FCAB28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8926 28.8398L86.5284 45.9251L81.9784 57.5458L38.6827 40.5937L42.8926 28.8398Z",
    fill: "#FFD733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6826 40.5935C38.6826 40.5935 35.6312 57.9259 53.5284 64.9334C71.4255 71.9409 81.977 57.5451 81.977 57.5451L38.6826 40.5935Z",
    fill: "#FCAB28"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5662 53.861L38.6816 40.5938C38.6816 40.5938 37.985 44.5591 39.2144 49.4617C41.4545 52.1522 44.664 54.63 49.2574 56.4285C59.788 60.5517 67.7749 57.2644 72.5662 53.861Z",
    fill: "#FFCE45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.0576 65.3529C48.0576 65.3529 45.1294 64.797 43.4863 68.4905L58.8265 74.4969C58.8265 74.4969 60.5733 71.0414 56.9194 68.8226L48.0562 65.3523L48.0576 65.3529Z",
    fill: "#FFD733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7822 67.8237L60.5317 75.1649C60.5317 75.1649 51.9668 97.0397 40.7994 105.477L36.027 103.609C36.027 103.609 33.491 90.0014 41.7822 67.8237Z",
    fill: "#FFD733"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7832 67.8235C36.5942 81.7047 35.6458 92.2265 35.6641 98.1578C38.63 98.9784 41.837 98.072 43.9457 95.7564C49.9825 89.1232 54.8664 79.5294 57.4236 73.9474L41.7846 67.824L41.7832 67.8235Z",
    fill: "#FFFFFD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.629 105.41L36.0273 103.609L32.8156 111.811L37.4173 113.613L40.629 105.41Z",
    fill: "#FCAB28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1847 107.256L34.3979 104.599C33.9655 104.43 33.7522 103.94 33.9219 103.507C34.0917 103.073 34.5806 102.859 35.013 103.028L41.7998 105.686C42.2321 105.855 42.4454 106.344 42.2757 106.778C42.106 107.211 41.617 107.426 41.1847 107.256Z",
    fill: "#FCAB28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9691 123.997C45.0362 116.251 37.4188 113.614 37.4188 113.614L32.8172 111.812C25.9987 109.142 21.5856 114.889 21.5856 114.889L43.9685 123.998L43.9691 123.997Z",
    fill: "#FFCE45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2403 114.776L31.4535 112.118C31.0212 111.949 30.8079 111.46 30.9776 111.026C31.1473 110.593 31.6363 110.378 32.0686 110.547L38.8554 113.205C39.2878 113.374 39.5011 113.864 39.3314 114.297C39.1616 114.731 38.6727 114.945 38.2403 114.776Z",
    fill: "#FCAB28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4163 125.406L20.9161 116.597C19.9743 116.228 19.5109 115.164 19.8807 114.22C20.2504 113.276 21.3126 112.81 22.2544 113.179L44.7546 121.988C45.6964 122.357 46.1598 123.421 45.7901 124.365C45.4204 125.309 44.3581 125.775 43.4163 125.406Z",
    fill: "#FFCE45"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2674 36.4261L51.8125 32.3325L47.2625 43.9532L57.7174 48.0468L62.2674 36.4261Z",
    fill: "#FFFFFD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.3579 43.9007L75.6768 41.6763L71.1268 53.297L76.8079 55.5214L81.3579 43.9007Z",
    fill: "#FFE266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3533 42.5765L48.695 40.0592L48.6145 43.5096L50.2133 45.4936L47.6797 45.7753L45.0217 49.1001L45.4199 44.8427L43.8202 42.8568L46.3533 42.5765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0562 89.1216C55.2629 88.2668 55.5242 93.0778 54.7196 96.3198C53.8985 99.6283 52.2368 103.248 46.9678 100.491C42.8391 98.3311 44.8495 89.9764 50.0562 89.1216Z",
    fill: "#085078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 17.5C78.5 17.5 89.5 23.5 94 33.5",
    stroke: "#08B7C7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 10C226.5 10 215.5 16 211 26",
    stroke: "#1DA9E2",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 144C40.5 144 67 152 71 163.5",
    stroke: "#DF6E04",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 121C254.5 125 237.776 133.08 227.275 149.58",
    stroke: "#08B6C8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.041 70.5481C263.041 70.5483 256.041 76.0481 249.041 84.5481",
    stroke: "#FF7A00",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5529 133.57L26.9428 139.519L34.6099 136.199L30.2739 143.196L35.6638 149.144L27.5941 147.52L23.2581 154.517L22.6068 146.516L14.5371 144.892L22.2042 141.571L21.5529 133.57Z",
    fill: "#DF6E04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9831 8.37624L65.685 13.3436L71.4851 12.3438L67.3549 16.4136L70.0568 21.381L64.8023 18.929L60.6721 22.9989L61.5548 17.4135L56.3003 14.9614L62.1004 13.9616L62.9831 8.37624Z",
    fill: "#08B7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.171 22.3023L270.393 27.9527L276.036 29.6254L270.53 31.4447L270.752 37.095L267.128 32.5691L261.622 34.3885L264.887 29.772L261.263 25.2461L266.906 26.9188L270.171 22.3023Z",
    fill: "#08B7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.5 120C280.833 119.334 286.5 119 290 119",
    stroke: "#08B6C8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 38,
    r: 1,
    fill: "#08B7C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32811_548",
    x: 104.069,
    y: 59.5876,
    width: 39.2715,
    height: 37.873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0291667 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32811_548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32811_548",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_32811_548",
    x: 158.628,
    y: 53.5615,
    width: 39.1689,
    height: 38.2305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0291667 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32811_548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32811_548",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32811_548",
    x1: 152.871,
    y1: 16,
    x2: 152.871,
    y2: 213.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderBorad);
export default __webpack_public_path__ + "static/media/leaderBorad.70d2832966a8331deb4c608929b30f70.svg";
export { ForwardRef as ReactComponent };